import { createAction } from 'deox';

export const resetStore = createAction('app/RESET_STORE');
